<div id="main" class="internal">
  <div id="restaurant" class="section restaurant">
    <div class="content-body">
      <div class="content">
        <div class="title">
          <h1>{{ "home.select_restaurant" | translate }}</h1>
        </div>

        <div class="subtitle">
          <p>{{ "home.subtitle" | translate }}</p>
        </div>

        <ul class="cards">
          <li
            class="card restaurant"
            *ngFor="let el of datasource; let i = index"
          >
            <p-radioButton
              [name]="el.name!"
              [value]="el"
              [(ngModel)]="selected"
              [inputId]="el.id_restaurant"
              styleClass="restaurantRadio"
            />
            <label [for]="el.id_restaurant" class="name">{{ el.name }}</label>
          </li>
        </ul>
      </div>

      <div class="buttons">
        <button
          class="costa-button"
          type="button"
          [disabled]="!this.selected"
          (click)="Continues()"
        >
          {{ "continue" | translate }}
        </button>
      </div>

      <!-- <button
        class="costa-button"
        type="button"
        (click)="conferma()"
        style="margin-bottom: 15px"
      >
        {{ "home.reservation_confirm" | translate }}
      </button>
      <button class="costa-button" type="button" (click)="chiudi()">
        {{ "home.close" | translate }}
      </button> -->
    </div>
  </div>
</div>
